class Navigation {
  constructor(el) {
    this.dom = {el: el};
    this.dom.target = this.dom.el.querySelectorAll('.g-navigation-list__label')

    // this.setDelay = this.setDelay.bind(this);

    this.init();
  }

  init() {
    const _this = this;
    function customHtml() {
      return new Promise((resolve) => {
        [..._this.dom.target].forEach((el, index, array) => {
          // テキストコンテンツを取得
          const textContent = el.textContent;
      
          // テキストコンテンツを一文字ずつ分割して<span>タグで囲んで新しい文字列を作成
          const newTextContent = [...textContent]
            .map((char) => `<span><span data-js="navigation-anim">${char}</span></span>`)
            .join('');
          // 新しい文字列をHTMLに挿入
          el.innerHTML = newTextContent;

          if (index === (array.length - 1)) {
            resolve();
          }
        })
      });
    }
    
    // 変数に代入された非同期関数式
    const startAnimation = async function () {
      await customHtml(true);
      return true;
    };
    
    startAnimation().then((v) => {
      // customHtmlの処理が終わったら実行
      _this.setDelay();
      _this.dom.el.dataset.is = 'set'
    });
  }

  setDelay() {
    const en = this.dom.el.querySelectorAll('[data-lang="en');
    const ja = this.dom.el.querySelectorAll('[data-lang="ja');
    [...en].forEach((el, index, array) => {
      const elms = el.querySelectorAll('[data-js="navigation-anim"]');
      [...elms].forEach((el, index, array) => {
        el.style.transitionDelay = `${index * .05}s`
      })
    });
    [...ja].forEach((el, index, array) => {
      const elms = el.querySelectorAll('[data-js="navigation-anim"]');
      [...elms].forEach((el, index, array) => {
        el.style.transitionDelay = `${index * .05}s`
      })
    })
  }
}

export default Navigation